import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag, Tooltip } from 'antd';
import DefaultStar from '../DefaultStar';
import styles from './style.module.less';
const RoleTagList = ({ roles, defaultRoleIndex }) => (_jsx("div", { className: styles.tagList, children: roles.map((role, idx) => (_jsxs(Tag, { className: styles.roleTag, children: [_jsx(Tooltip, { title: role, children: _jsx("div", { className: styles.roleLabel, children: role }) }), defaultRoleIndex !== undefined && idx === defaultRoleIndex && _jsx(DefaultStar, { marginLeft: true })] }, role))) }));
export default RoleTagList;
